export default "__VITE_ASSET__rOAyjbvI__"